import { Injectable } from '@angular/core';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import { Observable } from 'rxjs';
import { Rotas } from '@core/enums/routes';

import { ExecucaoModeloClima } from '@home/submodulos/previsao-climatica/interfaces/previsaoClimatica';
import {
  DetalhesMunicipioModeloPrevisaoClimatica,
  RespostaModeloPrevisaoClimatica
} from '../types/modelo-previsao-climatica-types';
import {MesEAno} from "@shared/types/calendarTypes";

@Injectable({
	providedIn: 'root',
})
export class ClimaService {
	constructor(private http: HttpClientProtectedService) {}

	listExecucoes(): Observable<ExecucaoModeloClima[]> {
		return this.http.get<ExecucaoModeloClima[]>(Rotas.CLIMA + '/execucoes');
	}

	listPrevisaoClimatica(
		idExecucao: number,
		variavel: string
	): Observable<PrevisaoClimaResponse> {
		const res = this.http.get<any>(Rotas.CLIMA + '/previsao', {
			idExecucao,
			variavel,
		});
		return res;
	}
}
export interface PrevisaoClimaResponse {
  data: MesEAno[];
  dadosMunicipio: DetalhesMunicipioModeloPrevisaoClimatica[];
}
